import React, { useState } from 'react'
import Button from 'react-bootstrap/Button';


const RandomForm = props =>  {
    const [name, setName] = useState('')
    const [details, setDetails] = useState('')
    const [box_number, setBox_Number] = useState('')


    const handleSubmit = (e) => {
        e.preventDefault()
        const boxinfo = {
            name:name,
            details:details,
            box_number:box_number
        }

        props.handleCreateRandom(boxinfo)
        .then(() => {
            props.handleClose()
            setName('')
            setDetails('')
            setBox_Number('')
        })
        .catch(err=>console.log(err))
    }



    return (
        <form onSubmit={handleSubmit}>
            <label htmlFor="new-random-name">
                Item:
                <input type="text" id="new-random-name" value={name} onChange={e => setName(e.target.value.toLowerCase())} required/>
            </label>
            <label htmlFor="new-random-details">
                Details(if any):
                <input type="text" id="new-random-details" value={details} onChange={e => setDetails(e.target.value.toLowerCase())}/>
            </label>
            <br/>
            <label htmlFor="new-random-box-number">
                Box #:
                <select value={box_number} onChange={e => setBox_Number(e.target.value)} id="new-random-box-number" className='dropdown' required>
                    <option value=""></option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                </select>
            </label><br/>
            <Button type="submit">Put in the Box</Button>
            <Button onClick={props.handleClose}>Cancel</Button>
        </form>
    )
}


export default RandomForm
